// extracted by mini-css-extract-plugin
module.exports = {"img":"ImageReturn_img__2s3jo"};